import { Col, Form, Row } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store/Reducers";
import { FC, useEffect } from "react";
import { handleSetMarketAnalysisReportFilter } from "../ClientSideStates";
import GeneralProvinces from "apps/Common/Adress/Components/GeneralProvince";

const TopFilters: FC<{ isMobile: boolean }> = ({ isMobile }) => {
  const [form] = Form.useForm();
  const { filter } = useSelector(
    (state: RootState) => state.marketAnalysisRepor
  );
  const { userInfoes } = useSelector((state: RootState) => state.profile);
  const dispatch = useDispatch();
  const handleChangeStateProvince = (value: string[]) => {
    const currentFilter = { ...filter };
    if (value) {
      currentFilter["cityIds"] = value;
    } else {
      delete currentFilter["cityIds"];
    }
    dispatch(handleSetMarketAnalysisReportFilter({ filter: currentFilter }));
  };
  useEffect(() => {
    form.setFieldsValue({
      cityIds: filter?.cityIds || undefined,
    });
  }, [filter]);
  return (
    <>
      <Row gutter={[10, 10]}>
        <Col xs={24}>
          <Form form={form}>
            <Row gutter={[10, 10]}>
              <GeneralProvinces
                xs={24}
                size="large"
                md={12}
                lg={8}
                xl={6}
                allowClear
                name={"cityIds"}
                mode="multiple"
                onChange={handleChangeStateProvince}
                label={isMobile ? "Bölge" : ""}
                placeholder="Bölge"
                externalValueId={userInfoes.id}
              />
            </Row>
          </Form>
        </Col>
      </Row>
    </>
  );
};

export default TopFilters;
